import React from 'react';
import {Box} from "@mui/material";
import {toAbsoluteUrl} from "../../../helper/utils";

const _TomanSvg = ({size = 14, color, sx = {}}) => {
    return (
        <Box
            component="img"
            src={toAbsoluteUrl("/assets/images/svg/toman.svg")}
            alt="تومان"
            sx={{
                width: size,
                height: size,
                display: "inline-block",
                verticalAlign: "middle",
                mx: 0.5,
                filter: color === "white" 
                    ? "brightness(0) invert(1)" 
                    : color === "primary"
                    ? "invert(27%) sepia(85%) saturate(3048%) hue-rotate(344deg) brightness(96%) contrast(92%)"
                    : (theme) => theme.palette.mode === 'dark' ? "brightness(0) invert(1)" : undefined,
                ".mode-dark &": {
                    filter: color === "primary"
                        ? "invert(27%) sepia(85%) saturate(3048%) hue-rotate(344deg) brightness(96%) contrast(92%)"
                        : "brightness(0) invert(1)"
                },
                ...sx
            }}
        />
    );
};

export default _TomanSvg;
